export default "__VITE_ASSET__6EcB2VBv__"